import axios from "axios";
import { BASE_URL } from "../utility/UrlConstants";
import { getHeaderConfig } from "utility/HeaderConfig";
import { TENANTID } from "utility/Constant";

const login = (requestBody: string) => {
  return axios
    .post(`${BASE_URL}/users/authenticate`, requestBody, {
      headers: {
        "Content-Type": "application/json",
        token: "",
      },
    })
    .then((response) => {
      let data = {};
      if (response.status === 200 && response != null) {
        data = response.data;
      }
      return data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const tokenN = getHeaderConfig();

const getUserAccount = async (userName) => {
  const responseData = await fetch(
    JSON.parse(await BASE_URL) +
      '/users/get-page?filters={"username":"' +
      userName +
      '"}',
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: tokenN,
        TenantId: TENANTID,
      },
    }
  )
    .then((response) => response.json())
    .then((json) => {
      return json.content;
    })
    .catch((error) => console.error(error))
    .finally(() => {});
  return responseData;
};

export { login, getUserAccount };
